import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette, breakpoints }: Theme) => ({
  backToTop: {
    position: 'sticky',
    bottom: '6rem',
    marginBottom: '2rem',
    marginLeft: 'auto',
    zIndex: 1,
    width: '3rem',
    height: '3rem',
    padding: '0.5rem',
    borderRadius: '1rem',
    border: `0.125rem solid ${palette.primary.main}`,
    backgroundColor: palette.common.white,
    color: palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    lineHeight: 1,
    [breakpoints.up('sm')]: {
      bottom: '4.75rem',
      marginBottom: '0',
    },
    '& img': {
      width: '2rem',
      height: '2rem',
    },
  },
}));
